import React from "react";
import {
  Crown,
  Sparkles,
  Gem,
  ShieldCheck,
  Heart,
  Flower2,
  Wand2,
  Smile,
} from "lucide-react";
import { WHY_US } from "../data/salonData";

const ICONS = { Crown, Sparkles, Gem, ShieldCheck, Heart, Flower2, Wand2, Smile };

export const WhyChooseUs = () => {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="py-24 sm:py-28 px-5 sm:px-8 lg:px-12 max-w-7xl mx-auto"
    >
      <div className="text-center max-w-2xl mx-auto reveal">
        <span className="label-eyebrow">Why Choose Us</span>
        <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight text-luxuryBlack">
          A salon that feels{" "}
          <span className="hero-script">like home</span>.
        </h2>
        <p className="mt-5 text-luxuryBlack/70">
          Eight reasons our Auckland clients keep coming back — and bring their
          friends, sisters and brides-to-be.
        </p>
      </div>

      <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-5 sm:gap-6">
        {WHY_US.map(({ title, desc, icon }, i) => {
          const Icon = ICONS[icon] || Sparkles;
          return (
            <div
              key={title}
              data-testid={`why-card-${i}`}
              className="reveal group glass-card rounded-3xl p-6 sm:p-7 hover:-translate-y-2 transition-transform duration-500"
            >
              <div className="w-12 h-12 rounded-2xl bg-roseGoldDeep flex items-center justify-center mb-5 group-hover:bg-roseGold transition-colors duration-500">
                <Icon className="w-6 h-6 text-white transition-colors duration-500" />
              </div>
              <h3 className="font-display text-lg sm:text-xl text-luxuryBlack leading-snug">
                {title}
              </h3>
              <p className="mt-2 text-sm text-luxuryBlack/65 leading-relaxed">
                {desc}
              </p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default WhyChooseUs;
